import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BehaviorSubject, Observable, filter } from 'rxjs';

/**
 * Détecte la disponibilité d'une nouvelle version de l'application (app-shell)
 * publiée via le service worker Angular, et permet de l'appliquer.
 *
 * Aucune donnée métier n'est concernée : il s'agit uniquement de la mise à jour
 * du shell statique mis en cache par le service worker.
 */
@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private readonly _updateReady$ = new BehaviorSubject<boolean>(false);

  /** Émet `true` lorsqu'une nouvelle version est prête à être activée. */
  readonly updateReady$: Observable<boolean> = this._updateReady$.asObservable();

  constructor(private readonly swUpdate: SwUpdate) {}

  /** À appeler au démarrage de l'application. No-op si le SW est désactivé. */
  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }
    this.swUpdate.versionUpdates
      .pipe(
        filter(
          (event): event is VersionReadyEvent => event.type === 'VERSION_READY',
        ),
      )
      .subscribe(() => this._updateReady$.next(true));
  }

  /**
   * Active la nouvelle version puis recharge la page.
   * `reload` est injectable pour la testabilité.
   */
  async applyUpdate(
    reload: () => void = () => document.location.reload(),
  ): Promise<void> {
    await this.swUpdate.activateUpdate();
    reload();
  }
}
